import { render, staticRenderFns } from "./psp-errors-filter.vue?vue&type=template&id=bfa87f3a&scoped=true"
import script from "./psp-errors-filter.vue?vue&type=script&lang=js"
export * from "./psp-errors-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa87f3a",
  null
  
)

export default component.exports